export default (props: { color?: string }) => (
	<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M22.167 3.5H17.29C16.8 2.147 15.517 1.167 14 1.167c-1.517 0-2.8.98-3.29 2.333H5.833A2.34 2.34 0 0 0 3.5 5.833v16.334A2.34 2.34 0 0 0 5.833 24.5h16.334a2.34 2.34 0 0 0 2.333-2.334V5.834A2.34 2.34 0 0 0 22.167 3.5zM14 3.5a1.17 1.17 0 0 1 1.167 1.167A1.17 1.17 0 0 1 14 5.832a1.17 1.17 0 0 1-1.167-1.167A1.17 1.17 0 0 1 14 3.5zm0 4.666c1.937 0 3.5 1.564 3.5 3.5 0 1.937-1.563 3.5-3.5 3.5a3.495 3.495 0 0 1-3.5-3.5c0-1.936 1.563-3.5 3.5-3.5zm7 14H7v-1.633c0-2.333 4.667-3.617 7-3.617s7 1.284 7 3.617v1.633z"
			fill={props.color || "#367BF5"}
		/>
	</svg>
);
